<script>
  import { currentRoute } from "../general/store";
  import { players } from "../general/store/index.js";
  let playerNames = ["Maria", "Jozef"];

  function remove(index) {
    playerNames = playerNames.filter((element, i) => {
      return i !== index;
    });
  }

  function start() {
    players.set(playerNames);
    currentRoute.set("/score");
  }
  $: startEnabled = !playerNames.every(name => name.trim().length > 0);
</script>

<style>
  button.full {
    width: 100%;
  }
</style>

{#each playerNames as player, i}
  <div class="columns">
    <div class="column is-full">
      <div class="field">
        <div class="control">
          <label class="label">Player {i + 1}</label>
          <input
            class="input"
            type="text"
            bind:value={player}
            placeholder="Player {i + 1}"
            style="max-width: 80%" />
          {#if i > 0}
            <button class="button is-danger" on:click={() => remove(i)}>
              X
            </button>
          {/if}
        </div>
      </div>
    </div>
  </div>
{/each}
<hr />

<div class="columns">
  <div class="column is-full">
    <button
      class="button is-info full is-size-5"
      on:click={() => {
        playerNames = playerNames.concat('');
      }}>
      add player
    </button>
  </div>
</div>

<div class="columns">
  <div class="column is-full">
    <button
      class="button is-success full is-size-5"
      on:click={start}
      disabled={startEnabled}>
      start game
    </button>
  </div>
</div>
